import type { MailFolder } from "@/lib/types/mail";

const STORAGE_KEY = "mail_folders_session_v2";

type FoldersSessionEntry = {
  accountId: number;
  folders: MailFolder[];
  savedAt: number;
};

function readAll(): FoldersSessionEntry[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as FoldersSessionEntry[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeAll(entries: FoldersSessionEntry[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  } catch {
    /* ignore */
  }
}

export function readFoldersSessionCache(accountId: number): MailFolder[] | null {
  const match = readAll().find((e) => e.accountId === accountId);
  if (!match || match.folders.length === 0) return null;
  return match.folders;
}

export function writeFoldersSessionCache(accountId: number, folders: MailFolder[]): void {
  const entry: FoldersSessionEntry = { accountId, folders, savedAt: Date.now() };
  const rest = readAll().filter((e) => e.accountId !== accountId);
  writeAll([entry, ...rest].slice(0, 4));
}

export function clearFoldersSessionCache(accountId: number): void {
  writeAll(readAll().filter((e) => e.accountId !== accountId));
}

export function clearAllFoldersSessionCache(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
